import request from '@/utils/request';
import { encryptAES } from '@/utils/cryptoJS';

export function login(data) {
  return request({
    url: '/api/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  let params = {
    d: Math.random()
  }
  return request({
    url: '/api/user',
    method: 'get',
    params
  })
}

export function logout() {
  return request({
    url: '/api/logout',
    method: 'post'
  })
}

export function log_out() {
  return request({
    url: '/api/auth/logout',
    method: 'get'
  })
}

export function getMenu() {
  return request({
    url: '/api/permission',
    method: 'get',
    params: {
      status: 1
    }
  })
}

export function getNopermission() {
  return request({
    url: '/api/permission/getNopermission',
    method: 'get',
    params: {
      status: 1
    }
  })
}

// flag: 1菜单 2按钮
export function getPermissionTree(flag) {
  return request({
    url: `/api/permission_tree/${flag}`,
    method: 'get'
  })
}
//获取手机验证码
export function get_phone_verification_code(data) {
  return request({
    url: '/api/sms/code',
    method: 'post',
    data
  })
}

//手机登录
export function phone_login(data) {
  return request({
    url: '/api/sms/login',
    method: 'post',
    data
  })
}
//获取邮箱验证码
export function get_email_verification_code(data) {
  return request({
    url: '/api/mail/code',
    method: 'post',
    data
  })
}

//邮箱登录
export function email_login(data) {
  return request({
    url: '/api/mail/login',
    method: 'post',
    data
  })
}

//手机+短信修改密码
export function phone_pass_edit(data) {
  return request({
    url: '/api/sms/pwd',
    method: 'post',
    data
  })
}

//邮箱+验证码修改密码
export function email_pass_edit(data) {
  return request({
    url: '/api/mail/pwd',
    method: 'post',
    data
  })
}

//注册
export function user_registration(data) {
  let n_data = { ...data }
  if (n_data.password) {
    n_data.password = encryptAES(n_data.password)
  }
  if (n_data.password_confirmation) {
    n_data.password_confirmation = encryptAES(n_data.password_confirmation)
  }
  return request({
    url: '/api/register',
    method: 'post',
    data: n_data
  })
}


//获取用户信息
export function get_user_info() {
  return request({
    method: 'get',
    url: '/api/user'
  })
}


export function getOpenid(params) {
  return request({
    url: '/api/openid',
    method: 'get',
    params
  })
}
// go Jupyter
export function goJupyter(params) {
  return request({
    url: '/api/abutment/goJupyter',
    method: 'get',
    params
  })
}

//个人中心商品信息
export function getConfInfo() {
  return request({
    url: '/api/get_conf_info',
    method: 'get',
  })
}

//生成订单
export function orderSave(data) {
  return request({
    url: '/api/order_save',
    method: 'post',
    data
  })
}

//支付
export function toPay(id, params) {
  return request({
    url: `/api/pay/${id}`,
    method: 'get',
    params
  })
}

//获取订单列表
export function getOrderList() {
  return request({
    url: '/api/order_list',
    method: 'get',
  })
}

//获取订单详情
export function getOrderShow(id) {
  return request({
    url: `/api/order_show/${id}`,
    method: 'get'
  })
}

export function vip_equity_user() {
  return request({
    url: `/api/system/vip_equity/user`,
    method: 'get'
  })
}
